import React from "react";
import { Section } from "./Section";
import { SectionHeading } from "./SectionHeading";
const points = [{
  title: "Dedicated volumes",
  text: "When educational materials are organized into dedicated volumes, it becomes easier to identify relevant topics, review terminology, and return to specific reference sections during study."
}, {
  title: "Case-based exercises",
  text: "Case-based educational exercises can also help professionals structure their review of nutritional information, identify relevant questions, and discuss clinical considerations in an organized manner."
}];
export function ApproachSection() {
  return <Section tone="white" cta={{
    label: "Get my GI Nutrition Blueprint",
    sub: "$27 USD · One-Time Payment · Instant Digital Access"
  }} data-id="element-2" data-mp="2aus7uf97tk7g">
      <SectionHeading eyebrow="What professionals look for in gastrointestinal nutrition education" title="A structured approach to professional learning" intro={<>
            <p data-id="element-4" data-mp="13zi2m1rkepwu">Gastrointestinal nutrition involves interconnected subjects, from digestive physiology and nutrient absorption to nutritional assessment, dietary considerations, and care planning.</p>
            <p data-id="element-5" data-mp="1csv25mk4wprw">A structured educational collection can provide a practical way to organize these topics and revisit them as part of continuing professional development.</p>
          </>} data-id="element-3" data-mp="33l1x9m5zsc8m" />
      <div className="mx-auto mt-10 grid max-w-4xl gap-8 md:grid-cols-2 md:gap-10" data-id="element-6" data-mp="1mpzslyl0j7ei">
        {points.map(p => <div key={p.title} className="border-t-2 border-brand pt-5" data-id="element-7" data-mp="1hqmx6pg2ss0b">
            <h3 className="font-display text-xl font-extrabold" data-id="element-8" data-mp="1vrzasu7rkhj1">{p.title}</h3>
            <p className="mt-2 text-[16px] leading-relaxed text-muted" data-id="element-9" data-mp="1rpvwzyxmh0ul">{p.text}</p>
          </div>)}
      </div>
      <p className="mx-auto mt-10 max-w-2xl text-center font-display text-[22px] font-extrabold leading-snug md:text-[28px]" data-id="element-10" data-mp="1cwnn366tbja">
        My aim is to give you a structured starting point for organizing your gastrointestinal nutrition references in one place.
      </p>
    </Section>;
}